import { render, staticRenderFns } from "./CallDuration.vue?vue&type=template&id=662cd812&"
import script from "./CallDuration.vue?vue&type=script&lang=js&"
export * from "./CallDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports